(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2814],{

/***/ 87113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "mo": function() { return /* binding */ ImageContainer; },
  "Zp": function() { return /* binding */ defaultAlt; }
});

// UNUSED EXPORTS: RegisterImgStyle

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./constants/path.ts
var path = __webpack_require__(96703);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/SmallPrintTerms/style.module.scss
var style_module = __webpack_require__(10416);
var style_module_default = /*#__PURE__*/__webpack_require__.n(style_module);
;// CONCATENATED MODULE: ./components/SmallPrintTerms/index.tsx






var privacyPolicyUrl = appClientConfig/* appClientConfig.privacyPolicyUrl */.p.privacyPolicyUrl;
var SmallPrintTerms = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (style_module_default()).smallPrint,
        children: [
            "Our",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                as: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: path/* PATH.TERMS_AND_CONDITIONS */.m.TERMS_AND_CONDITIONS,
                    children: "Terms of Use"
                })
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                prefetch: false,
                href: privacyPolicyUrl,
                as: privacyPolicyUrl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    className: (style_module_default()).link,
                    href: privacyPolicyUrl,
                    children: "Privacy Policy"
                })
            })
        ]
    });
};
/* harmony default export */ var components_SmallPrintTerms = (SmallPrintTerms);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
;// CONCATENATED MODULE: ./components/Image/img/quote.svg
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

var SvgQuote = function SvgQuote(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 52,
    height: 46,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M12.79 46c-3.927 0-7.068-1.42-9.424-4.26C1.122 38.789 0 34.984 0 30.327c0-6.36 1.683-12.096 5.049-17.207C8.526 7.894 13.799 3.52 20.867 0l1.851 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.841 2.555.561.568 1.403.852 2.525.852 2.804 0 5.16 1.023 7.068 3.067 2.019 1.93 3.029 4.316 3.029 7.155 0 2.84-1.01 5.225-3.03 7.156C17.95 45.091 15.595 46 12.79 46Zm29.113 0c-3.927 0-7.068-1.42-9.424-4.26-2.244-2.952-3.366-6.757-3.366-11.414 0-6.36 1.683-12.096 5.049-17.207C37.64 7.894 42.912 3.52 49.98 0l1.85 2.726c-3.365 2.044-6.45 4.94-9.255 8.689-2.693 3.634-4.039 7.326-4.039 11.074 0 1.022.28 1.874.842 2.555.56.568 1.402.852 2.524.852 2.805 0 5.16 1.023 7.068 3.067C50.99 30.893 52 33.279 52 36.118c0 2.84-1.01 5.225-3.03 7.156C47.065 45.091 44.709 46 41.904 46Z",
    fill: "#C0E8FF"
  })));
};
/* harmony default export */ var quote = (SvgQuote);
// EXTERNAL MODULE: ./components/Image/style.module.scss
var Image_style_module = __webpack_require__(20027);
var Image_style_module_default = /*#__PURE__*/__webpack_require__.n(Image_style_module);
;// CONCATENATED MODULE: ./components/Image/index.tsx
/* eslint-disable react/jsx-boolean-value */ 







var defaultAlt = "Medrecruit Image";
var convertToArray = function(item) {
    return Array.isArray(item) ? item : [
        item
    ];
};
var RegisterImgStyle;
(function(RegisterImgStyle) {
    RegisterImgStyle["Img"] = "img";
    RegisterImgStyle["OverlayImage"] = "overlayImage";
})(RegisterImgStyle || (RegisterImgStyle = {}));
var ImageContainer = function(param) {
    var img = param.img, imgStyle = param.imgStyle, imgAlt = param.imgAlt, overlayCenteredText = param.overlayCenteredText, overlayTextInBox = param.overlayTextInBox, width = param.width, height = param.height, whiteBackground = param.whiteBackground;
    var text = overlayCenteredText || overlayTextInBox;
    var textStyle = overlayCenteredText ? (Image_style_module_default()).centeredText : (Image_style_module_default()).overlayCenteredTextInBox;
    var termsStyle = overlayTextInBox ? (Image_style_module_default()).greyText : overlayCenteredText ? (Image_style_module_default()).hidden : (Image_style_module_default()).whiteText;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Image_style_module_default()).imgContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()(imgStyle === RegisterImgStyle.OverlayImage ? (Image_style_module_default()).overlayImage : (Image_style_module_default()).img),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    priority: true,
                    width: width,
                    height: height,
                    src: img,
                    alt: imgAlt || defaultAlt,
                    title: imgAlt || defaultAlt
                })
            }),
            text && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classnames_default()((Image_style_module_default()).textContainer, textStyle, whiteBackground && (Image_style_module_default()).whiteBackground),
                children: [
                    overlayTextInBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(quote, {}),
                    convertToArray(text).map(function(text, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: overlayCenteredText ? "h4" : index === 0 ? "subtitle1" : "caption",
                            display: "block",
                            component: "p",
                            children: text
                        }, "".concat(text, "-").concat(index));
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classnames_default()((Image_style_module_default()).finePrint, termsStyle, whiteBackground && (Image_style_module_default()).paleBlueText),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SmallPrintTerms, {})
            })
        ]
    });
};


/***/ }),

/***/ 45565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ registration_flow_old; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./types/registration.ts
/**
 * Matching the RegistrationDTO in the API
 */ var DefaultRegisterForm = {
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    phoneArea: "",
    grade: "",
    speciality: {
        key: "",
        value: ""
    },
    specialityTextarea: "",
    countryOfPrimaryDegree: {
        key: "",
        value: ""
    },
    graduationDate: undefined,
    registeredOrg: "",
    countryOfTraining: {
        key: "",
        value: ""
    },
    countriesWorkedIn: [],
    preferredWorkLocation: {
        key: "",
        value: ""
    },
    proposedReferred: "",
    subscriptions: [],
    preferredAvailability: {
        key: "",
        value: ""
    },
    preferredWorkType: {
        key: "",
        value: ""
    },
    registrationNumber: "",
    referralCode: ""
};

;// CONCATENATED MODULE: ./utils/getRegisterCopy.ts
/**
 * Gets the conditional copy for the Registration flow
 *
 * @param action defines where the user will redirect to. Used for the initial title
 * @param whitepaperSlug the identifier of the whitepaper that user has requested
 * @returns an Object with the titles of each RegisterStage
 */ var getRegisterCopy = function(action, whitepaperSlug) {
    return {
        basicInfo: getBasicInfoTitle(action),
        simple: whitepaperSlug ? "Help us get to know you" : "Let's find the right job for you",
        subscriptions: "Thanks, almost done!",
        verifyEmail: getVerifyEmailCopy(whitepaperSlug)
    };
};
/**
 * Get's the initial title string for the Registration flow,
 * depending on where the user is to be redirected to afterwards.
 *
 * @param action defines where the user will redirect to
 * @returns an Object with two titles. One main and one small
 */ var getBasicInfoTitle = function(action) {
    switch(action){
        case "enquire_job":
            return {
                smTitle: "Welcome!",
                mainTitle: "Enquire about this job by signing up"
            };
        case "save_job":
            return {
                smTitle: "Welcome!",
                mainTitle: "Save this job by signing up"
            };
        case "create_job_alert":
            return {
                smTitle: "Welcome back!",
                mainTitle: "Save this job alert by signing up"
            };
        case "whitepaper":
            return {
                smTitle: "",
                mainTitle: "Sign in, or create an account to access our resources"
            };
        default:
            return {
                smTitle: "First things first",
                mainTitle: "Let's get you on board"
            };
    }
};
/**
 * Gets the copy for the verify email modal at the end of the registration flow depending on
 * whether the user has requested a whitepaper or not.
 *
 * @param whitepaperSlug the identifier of the whitepaper that the user has requested
 * @returns An object of the copy for the Verify Email modal that pops up at the end of the registration flow
 */ var getVerifyEmailCopy = function(whitepaperSlug) {
    return whitepaperSlug ? {
        title: "Check your inbox.\nYour document is on its way!",
        description: "We've sent you an email to verify it's you. Open it up, click the link and login to be a part of the Medrecruit community!",
        resendMessage: "Didn't receive an email?\n Check your junk folder or resend.",
        buttonText: "Resend verification email"
    } : {
        title: "Verify your email address",
        description: "We've sent you a verification email. Open it up, click the link and login. That's it! You're part of the Medrecruit community.",
        resendMessage: "Didn't receive an email? Check your junk folder or select 'resend'.",
        buttonText: "Resend verification email"
    };
};

// EXTERNAL MODULE: ./utils/jobSearchCookies.tsx
var jobSearchCookies = __webpack_require__(80059);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
// EXTERNAL MODULE: ./utils/useRequest.ts
var useRequest = __webpack_require__(87243);
;// CONCATENATED MODULE: ./utils/userStateData.ts
/**
 * Utilities for storing user data between pages and visits
 */ var LoginFormInitData = "LoginFormInitData";

// EXTERNAL MODULE: ./modules/Layout/index.tsx + 6 modules
var Layout = __webpack_require__(83361);
// EXTERNAL MODULE: ./modules/RegistrationFlow/steps-old/RegisterBasicInfo/RegisterBasicInfo.tsx + 4 modules
var RegisterBasicInfo = __webpack_require__(35545);
;// CONCATENATED MODULE: ./modules/RegistrationFlow/steps-old/RegisterBasicInfo/index.tsx


// EXTERNAL MODULE: ./modules/Whitepapers/whitepapers.ts
var whitepapers = __webpack_require__(2275);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 4 modules
var format = __webpack_require__(42298);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./modules/RegistrationFlow/registration-flow-old.tsx



















var RegisterSimple = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4872), __webpack_require__.e(3496), __webpack_require__.e(3437), __webpack_require__.e(2946), __webpack_require__.e(2532)]).then(__webpack_require__.bind(__webpack_require__, 78153));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78153)
            ];
        }
    }
});
var RegisterVerifyEmail = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 764).then(__webpack_require__.bind(__webpack_require__, 10764));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10764)
            ];
        }
    }
});
var RegistrationFlowOld = function(param) {
    var previousRoute = param.previousRoute, preAction = param.preAction, referralCode = param.referralCode, metadata = param.metadata, whitepaperSlug = param.whitepaperSlug;
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var ref = (0,react.useState)(), registerError = ref[0], setRegisterError = ref[1];
    var ref1 = (0,react.useState)([
        "basicInfo"
    ]), stage = ref1[0], setStage = ref1[1];
    var ref2 = (0,react.useState)(DefaultRegisterForm), formData = ref2[0], setFormData = ref2[1];
    var ref3 = (0,react.useState)(false), canRegister = ref3[0], setCanRegister = ref3[1];
    var jobSearchGrade = (0,react.useRef)((0,jobSearchCookies/* getGradeCookie */.Dy)());
    var jobSearchSpecialty = (0,react.useRef)((0,jobSearchCookies/* getSpecialityCookie */.nj)());
    var jobSearchPreferredWorkLocation = (0,react.useRef)((0,jobSearchCookies/* mapJobSearchLocationCookieToPreferredWorkLocation */.yD)((0,jobSearchCookies/* getLocationCookie */.Jz)()));
    var isOnboardingQuestionsPrefilled = !!jobSearchGrade.current || !!jobSearchSpecialty.current || !!jobSearchPreferredWorkLocation.current;
    var trackingParams = {
        onboarding_questions_prefilled: isOnboardingQuestionsPrefilled,
        grade_prefilled: !!jobSearchGrade.current,
        speciality_prefilled: !!jobSearchSpecialty.current,
        preferred_workLocation_prefilled: !!jobSearchPreferredWorkLocation.current
    };
    var registerCopy = getRegisterCopy(preAction, whitepaperSlug);
    var currentStage = stage[stage.length - 1];
    var onNext = function(nextStage) {
        return setStage(function(prevStage) {
            prevStage.push(nextStage);
            return (0,_to_consumable_array/* default */.Z)(prevStage);
        });
    };
    var onGoback = function() {
        return setStage(function(prevStage) {
            prevStage.pop();
            var sortedStage = prevStage.length > 1 ? prevStage : [
                "basicInfo"
            ];
            return (0,_to_consumable_array/* default */.Z)(sortedStage);
        });
    };
    (0,react.useEffect)(function() {
        track("user registration started", {
            whitepaperName: whitepaperSlug
        });
    }, []);
    var getJobSearchFormData = function() {
        var ref, ref1;
        var jobSearchFormData = {};
        if (jobSearchGrade.current && jobSearchGrade.current !== "none" && !(formData === null || formData === void 0 ? void 0 : formData.grade)) {
            jobSearchFormData.grade = jobSearchGrade.current;
        }
        if (jobSearchSpecialty.current && jobSearchSpecialty.current !== "none" && !(formData === null || formData === void 0 ? void 0 : (ref = formData.speciality) === null || ref === void 0 ? void 0 : ref.key)) {
            jobSearchFormData.speciality = {
                key: jobSearchSpecialty.current,
                value: jobSearchSpecialty.current
            };
        }
        if (jobSearchPreferredWorkLocation.current && !(formData === null || formData === void 0 ? void 0 : (ref1 = formData.preferredWorkLocation) === null || ref1 === void 0 ? void 0 : ref1.key)) {
            jobSearchFormData.preferredWorkLocation = jobSearchPreferredWorkLocation.current;
        }
        return jobSearchFormData;
    };
    (0,react.useEffect)(function() {
        var jobSearchFormData = getJobSearchFormData();
        var localStorageFormData = localStorage.getItem(LoginFormInitData);
        if (localStorageFormData) {
            var ref = JSON.parse(localStorageFormData), firstName = ref.firstName, lastName = ref.lastName, email = ref.email, area = ref.area, phone = ref.phone;
            setFormData((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData, jobSearchFormData), {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phoneArea: area,
                phone: phone
            }));
            localStorage.removeItem(LoginFormInitData);
        } else {
            setFormData((0,_object_spread/* default */.Z)({}, formData, jobSearchFormData));
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react.useEffect)(function() {
        var registerPost = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var ref, ref1, ref2, ref3, ref4, ref5, ref6, sortData, ref7, result, errMessage;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            sortData = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, formData), {
                                grade: formData === null || formData === void 0 ? void 0 : formData.grade,
                                speciality: formData === null || formData === void 0 ? void 0 : (ref = formData.speciality) === null || ref === void 0 ? void 0 : ref.key,
                                preferredWorkLocation: formData === null || formData === void 0 ? void 0 : (ref1 = formData.preferredWorkLocation) === null || ref1 === void 0 ? void 0 : ref1.key,
                                preferredAvailability: formData === null || formData === void 0 ? void 0 : (ref2 = formData.preferredAvailability) === null || ref2 === void 0 ? void 0 : ref2.key,
                                preferredWorkType: formData === null || formData === void 0 ? void 0 : (ref3 = formData.preferredWorkType) === null || ref3 === void 0 ? void 0 : ref3.key,
                                graduationDate: (formData === null || formData === void 0 ? void 0 : formData.graduationDate) && (0,format/* default */.Z)(formData === null || formData === void 0 ? void 0 : formData.graduationDate, "yyyy-MM-01"),
                                countryOfPrimaryDegree: formData === null || formData === void 0 ? void 0 : (ref4 = formData.countryOfPrimaryDegree) === null || ref4 === void 0 ? void 0 : ref4.key,
                                countriesWorkedIn: formData === null || formData === void 0 ? void 0 : (ref5 = formData.countriesWorkedIn) === null || ref5 === void 0 ? void 0 : ref5.map(function(countryCodePair) {
                                    return countryCodePair.key;
                                }),
                                countryOfTraining: formData === null || formData === void 0 ? void 0 : (ref6 = formData.countryOfTraining) === null || ref6 === void 0 ? void 0 : ref6.key,
                                phone: formData === null || formData === void 0 ? void 0 : formData.phone,
                                redirectUrl: previousRoute !== null && previousRoute !== void 0 ? previousRoute : undefined,
                                referralCode: referralCode !== null && referralCode !== void 0 ? referralCode : undefined
                            });
                            if (whitepaperSlug) {
                                ;
                                sortData.whitepaperName = (ref7 = whitepapers/* whitepapers.get */.j.get(whitepaperSlug)) === null || ref7 === void 0 ? void 0 : ref7.name;
                                // Don't redirect back to the whitepaper page after account verification, the user has already been sent the paper
                                sortData.redirectUrl = undefined;
                            }
                            return [
                                4,
                                (0,useRequest/* submitRegister */.sJ)(sortData)
                            ];
                        case 1:
                            result = _state.sent();
                            if ("error" in result) {
                                errMessage = result.error.message || "Register Error. Please try again.";
                                track("user registration failed", {
                                    details: result.error
                                });
                                setRegisterError(errMessage);
                            } else {
                                track("user registration completed", {
                                    whitepaperName: whitepaperSlug
                                });
                                result.response.data.userId && onNext("verifyEmail");
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function registerPost() {
                return _ref.apply(this, arguments);
            };
        }();
        if (canRegister) {
            registerPost();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        canRegister
    ]);
    var initState = function() {
        setStage([
            "basicInfo"
        ]);
        setCanRegister(false);
    };
    if (formData === undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* Layout */.A, {
        onClickRegisterFn: initState,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                canonical: "/register",
                title: metadata.title,
                description: metadata.description,
                openGraph: {
                    title: metadata.title,
                    description: metadata.description
                }
            }),
            currentStage === "basicInfo" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterBasicInfo/* default */.ZP, {
                whitepaperSlug: whitepaperSlug,
                formData: formData && formData,
                onContinue: function(data) {
                    track("user registration basic info completed", {
                        whitepaperName: whitepaperSlug
                    });
                    setFormData((0,_object_spread/* default */.Z)({}, formData, data));
                    onNext("simple");
                },
                preAction: preAction,
                previousRoute: previousRoute
            }),
            currentStage === "simple" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterSimple, {
                title: registerCopy["simple"],
                formData: formData,
                onContinue: function(data) {
                    var ref;
                    var ref1;
                    track("user registration simple flow completed", (0,_object_spread/* default */.Z)({
                        whitepaperName: whitepaperSlug,
                        grade: data.grade,
                        speciality: (ref1 = (ref = data.speciality) === null || ref === void 0 ? void 0 : ref.value) !== null && ref1 !== void 0 ? ref1 : "not specified"
                    }, trackingParams));
                    setFormData((0,_object_spread/* default */.Z)({}, formData, data));
                    setCanRegister(true);
                },
                registerError: registerError,
                trackingParams: trackingParams
            }),
            currentStage === "verifyEmail" && /*#__PURE__*/ (0,jsx_runtime.jsx)(RegisterVerifyEmail, {
                email: formData && formData.email,
                verifyEmailCopy: registerCopy["verifyEmail"]
            })
        ]
    });
};
/* harmony default export */ var registration_flow_old = (RegistrationFlowOld);


/***/ }),

/***/ 80059:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dy": function() { return /* binding */ getGradeCookie; },
/* harmony export */   "Hl": function() { return /* binding */ setLocationCookie; },
/* harmony export */   "Jz": function() { return /* binding */ getLocationCookie; },
/* harmony export */   "Me": function() { return /* binding */ setSpecialityCookie; },
/* harmony export */   "nj": function() { return /* binding */ getSpecialityCookie; },
/* harmony export */   "r8": function() { return /* binding */ setGradeCookie; },
/* harmony export */   "yD": function() { return /* binding */ mapJobSearchLocationCookieToPreferredWorkLocation; }
/* harmony export */ });
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47041);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);

var JOB_SEARCH_GRADE_COOKIE = "mr-job-search-grade";
var JOB_SEARCH_SPECIALITY_COOKIE = "mr-job-search-speciality";
var JOB_SEARCH_LOCATION_COOKIE = "mr-job-search-location";
var JOB_SEARCH_COOKIE_LIFE_IN_MS = 24 * 60 * 60 * 1000; // 24 hours
var getGradeCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_GRADE_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setGradeCookie = function(grade) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_GRADE_COOKIE, grade, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getSpecialityCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_SPECIALITY_COOKIE);
    if (value && typeof value === "string") {
        return value;
    }
    return null;
};
var setSpecialityCookie = function(speciality) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_SPECIALITY_COOKIE, speciality, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var getLocationCookie = function() {
    var value = (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)(JOB_SEARCH_LOCATION_COOKIE);
    if (value && typeof value === "string") {
        var parsedValue;
        try {
            parsedValue = JSON.parse(value);
        } catch (_e) {
            return null;
        }
        if ((parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.name) && (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.country)) {
            return {
                name: parsedValue.name,
                state: parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.state,
                country: parsedValue.country
            };
        }
    }
    return null;
};
var setLocationCookie = function(locationCoordinate) {
    var value = JSON.stringify({
        name: locationCoordinate.name,
        state: locationCoordinate === null || locationCoordinate === void 0 ? void 0 : locationCoordinate.state,
        country: locationCoordinate.country
    });
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)(JOB_SEARCH_LOCATION_COOKIE, value, {
        expires: new Date(Date.now() + JOB_SEARCH_COOKIE_LIFE_IN_MS)
    });
};
var mapJobSearchLocationCookieToPreferredWorkLocation = function(locationCookie) {
    if (!locationCookie) {
        return null;
    }
    // country level
    if (locationCookie.name === "New Zealand") {
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    if (locationCookie.name === "Australia") {
        return {
            key: "Australia",
            value: "Anywhere in Australia"
        };
    }
    // NZ locations
    if (locationCookie.country === "New Zealand") {
        if (locationCookie.name === "South Island") {
            return {
                key: "South Island of New Zealand",
                value: "South Island of New Zealand"
            };
        }
        if (locationCookie.name === "North Island") {
            return {
                key: "North Island of New Zealand",
                value: "North Island of New Zealand"
            };
        }
        return {
            key: "New Zealand",
            value: "Anywhere in New Zealand"
        };
    }
    // AU locations
    if (locationCookie.country === "Australia") {
        if (locationCookie.name === "Victoria" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Victoria") {
            return {
                key: "Victoria Australia",
                value: "Victoria Australia"
            };
        }
        if (locationCookie.name === "New South Wales" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "New South Wales") {
            return {
                key: "New South Wales Australia",
                value: "New South Wales Australia"
            };
        }
        if (locationCookie.name === "Queensland" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Queensland") {
            return {
                key: "Queensland Australia",
                value: "Queensland Australia"
            };
        }
        if (locationCookie.name === "South Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "South Australia") {
            return {
                key: "South Australia",
                value: "South Australia"
            };
        }
        if (locationCookie.name === "Australian Capital Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Australian Capital Territory") {
            return {
                key: "Australian Capital Territory",
                value: "Australian Capital Territory"
            };
        }
        if (locationCookie.name === "Tasmania" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Tasmania") {
            return {
                key: "Tasmania Australia",
                value: "Tasmania Australia"
            };
        }
        if (locationCookie.name === "Western Australia" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Western Australia") {
            return {
                key: "Western Australia",
                value: "Western Australia"
            };
        }
        if (locationCookie.name === "Northern Territory" || (locationCookie === null || locationCookie === void 0 ? void 0 : locationCookie.state) === "Northern Territory") {
            return {
                key: "Northern Territory Australia",
                value: "Northern Territory Australia"
            };
        }
    }
    return null;
};


/***/ }),

/***/ 20027:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"style_imgContainer__okrSE","img":"style_img__XGlaq","overlayImage":"style_overlayImage__JBqLw","textContainer":"style_textContainer__Amkh2","centeredText":"style_centeredText__2FA7k","overlayCenteredTextInBox":"style_overlayCenteredTextInBox__Fudym","finePrint":"style_finePrint__Jzs6x","whiteText":"style_whiteText__k32cQ","greyText":"style_greyText__NEUAp","hidden":"style_hidden__EqpuW","centeredImg":"style_centeredImg__t2PIR","droplets":"style_droplets__Y3htk","whiteBackground":"style_whiteBackground__ByG1F","paleBlueText":"style_paleBlueText__yr_OJ"};

/***/ }),

/***/ 10416:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"smallPrint":"style_smallPrint__n1vZC"};

/***/ })

}]);